<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row justify-content-between">
        <div class="col-6">
          <h6>Lista de Usuarios Asistidos</h6>
        </div>

        <div class="col-6">
          <div class="row justify-content-end">
            <div class="col-6 col-md-4" style="text-align: right !important">
              <button
                v-if="getUser.idRol != 1"
                type="button"
                class="btn btn-success mb-0"
                @click="openModal = true"
              >
                <i class="fas fa-user-plus"></i> Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pb-2">
      <div class="container-fluid">
        <div v-if="!loading" class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-bordered align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Acciones
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Estado
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Fecha de Caducidad
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Identificación del Cliente
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Identificación del Asesor
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Nombre del Asesor
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Banco
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xs font-weight-bolder"
                    >
                      Fecha y Hora
                    </th>
                  </tr>
                </thead>
                <tbody v-if="displayedPosts.length">
                  <tr v-for="item of displayedPosts" :key="item.id">
                    <td class="text-center">
                      <Tooltip
                        v-if="getUser.idRol != 1 && item.idEstado == 1"
                        tooltipText="Eliminar Usuario"
                        position="right"
                      >
                        <button
                          type="button"
                          @click="changeStatus(item, 17)"
                          class="btn btn-danger btn-sm px-2 mx-1 mb-0 text-light"
                        >
                          <span class="fas fa-user-times"></span>
                        </button>
                      </Tooltip>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm null null"
                        :class="{
                          'bg-gradient-success': item.idEstado == 18,
                          'bg-gradient-danger': [17, 19].includes(
                            item.idEstado
                          ),
                          'bg-gradient-secondary': item.idEstado == 1,
                        }"
                      >
                        {{ item.nombreEstado }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">
                        {{ formatDate(new Date(item.fechaCaducidad)) }}
                      </h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">{{ item.dniCliente }}</h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">{{ item.dniAsesor }}</h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">{{ item.nombreAsesor }}</h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">{{ item.nombreBanco }}</h6>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <h6 class="mb-0 text-sm">
                        {{ formatDate(new Date(item.fechaCreacion)) }}
                      </h6>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9" class="text-center">
                      <h6 class="mb-0 text-sm">Sin resultados.</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 d-flex">
            <v-pagination
              class="ms-md-auto my-3"
              v-model="page"
              :pages="pages"
              :range-size="1"
              active-color="#DCEDFF"
              @update:modelValue="page"
            />
          </div>
        </div>
        <div v-else class="row">
          <div class="col-12 text-center">
            <span
              v-if="loading"
              class="fas fa-circle-notch fa-spin fa-2x mb-4"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalAddUserAssisted
    :isOpen="openModal"
    :user="getUser"
    @close-modal="closeModalAdd"
  />
</template>

<script>
import { ref, toRefs, computed } from 'vue';
import VPagination from '@hennge/vue3-pagination';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';
import Tooltip from '@/components/Tooltip.vue';
import { formatDate } from '@/utils/functions';
import Swal from 'sweetalert2';
import axiosInstance from '@/services/api';
import ModalAddUserAssisted from './ModalAddUserAssisted.vue';
import { useStore } from 'vuex';

export default {
  name: 'projects-card',

  props: {
    userList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pages: {
      type: Number,
      default: 1,
    },
    perPages: {
      type: Number,
      default: 10,
    },
  },

  components: {
    VPagination,
    Tooltip,
    ModalAddUserAssisted,
  },

  setup(props) {
    const store = useStore();

    const { getUser } = store.getters;

    const { perPages } = toRefs(props);
    const page = ref(1);
    const openModal = ref(false);

    const paginate = (data) => {
      let _page = page.value;
      let _perPage = perPages.value;
      let _from = _page * _perPage - _perPage;
      let _to = _page * _perPage;
      return data.slice(_from, _to);
    };

    const displayedPosts = computed(() => {
      const list = props.userList;

      return paginate(list);
    });

    // Agregar Usuario
    const closeModalAdd = () => {
      openModal.value = false;
    };

    const changeStatus = (item, status) => {
      Swal.fire({
        title: `¿Está seguro de Eliminar al usuario <span class="text-danger">${item.dniCliente}</span>?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return new Promise((resolve, reject) => {
            try {
              axiosInstance
                .put(`/usersAssited/changeStatus/`, {
                  documento: item.dniCliente,
                  idBanco: item.idBanco,
                  status: status,
                })
                .then(() => {
                  item.idEstado = status;

                  resolve(true);
                })
                .catch((err) => {
                  if (err.response.status === 401) return;

                  Swal.fire({
                    title: 'Inconveniente en el sistema, intente más tarde',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar',
                  });
                });
            } catch (e) {
              reject(false);
            }
          });
        },
      });
    };

    return {
      page,
      displayedPosts,
      getUser,
      formatDate,
      openModal,
      closeModalAdd,
      changeStatus,
    };
  },
};
</script>

<style scoped>
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px !important;
}
</style>
